export default __webpack_public_path__ + "static/media/gift_10_expired.0f52db2d.png";